/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stock': {
    width: 18,
    height: 22,
    viewBox: '0 0 18 22',
    data: '<path pid="0" d="M17.7 3.4l-5.5-3a2.125 2.125 0 0 1-.2-.119c-.055.04-.122.08-.2.119l-5.5 3c-.2.1-.3.2-.3.4v5.5L.7 12.1c-.1.1-.2.2-.2.4v5.8c0 .2.1.3.2.4l5.5 2.9H6.5l11-5.8c.1-.1.2-.2.2-.4V3.8v-.4zm-3.8-1.1L9.2 4.8l-1.8-1L12 1.3l1.9 1zm-5.7 8.6l-4.6 2.4-1.7-.9L6.4 10l1.8.9zM6 20.5L1.3 18v-4.9l4.6 2.4.1.1v4.9zm-1.6-6.6L9 11.5l2 1.1L8.2 14l-1.7.9-2.1-1zm7.1 4.2l-4.7 2.5v-4.9l1.7-.9 3-1.6v4.9zm0-6.3L6.8 9.3V4.5L11.5 7v4.8zm.5-5.6l-1.9-1 4.7-2.5 1.9 1-3.7 2-1 .5zm.4 11.5v-4.9l4.7-2.5v4.9l-4.7 2.5zm4.7-8.4l-4.7 2.5V6.9l.9-.5 3.8-2v4.9z" _fill="#979797" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/stock.js